import { tr } from '@/lib/i18n';
import { RefreshCw, X } from 'lucide-react';
import { usePWAUpdate } from '@/hooks/usePWAUpdate';

/**
 * Last-resort fallback shown only when the user has been idle on the same
 * route for 15+ minutes with a pending SW update. For normal usage, the
 * update applies silently on the next navigation (see usePWAUpdate hook).
 *
 * Style: non-modal snackbar, bottom-center, auto-dismissable. No blocking.
 */
export function UpdateSnackbar() {
  const { showSnackbar, applyUpdate, dismissSnackbar } = usePWAUpdate();

  if (!showSnackbar) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 animate-in fade-in slide-in-from-bottom-4 duration-300"
    >
      <div className="flex items-center gap-3 rounded-full border border-border/60 bg-card/95 px-4 py-3 shadow-lg backdrop-blur-sm">
        <RefreshCw className="h-4 w-4 text-primary" aria-hidden="true" />
        <span className="text-sm text-foreground">{tr("A new version is ready.")}</span>
        <button
          type="button"
          onClick={applyUpdate}
          className="rounded-full bg-primary px-3 py-1 text-xs font-medium text-primary-foreground transition-opacity hover:opacity-90"
        >{tr("Refresh")}</button>
        <button
          type="button"
          onClick={dismissSnackbar}
          aria-label={tr("Dismiss")}
          className="text-muted-foreground transition-colors hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
